
import { useState, useEffect } from 'react';

const Hero = () => {
  return (
    <section id="accueil" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Vidéo en arrière-plan */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-0"
        poster="https://readdy.ai/api/search-image?query=Professional%20chef%20preparing%20exquisite%20gourmet%20dishes%20in%20a%20modern%20luxury%20kitchen%20with%20elegant%20plating%20and%20artistic%20presentation%2C%20warm%20golden%20lighting%20creating%20dramatic%20shadows%2C%20sophisticated%20culinary%20artistry%20in%20action%2C%20fine%20dining%20restaurant%20atmosphere%20with%20premium%20ingredients%2C%20high-end%20gastronomy%20excellence%2C%20French%20cuisine%20mastery%20with%20beautiful%20food%20styling%2C%20culinary%20perfection%20and%20gastronomic%20innovation&width=1920&height=1080&seq=hero-main&orientation=landscape"
      >
        <source src="/videos/hero-video.mp4" type="video/mp4" />
        Votre navigateur ne supporte pas la lecture de vidéos.
      </video>

      {/* Overlay léger pour la lisibilité */}
      <div className="absolute inset-0 bg-black/40 z-20"></div>

      {/* Contenu principal */}
      <div className="relative z-30 container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto bg-black/30 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
          {/* Titre principal */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 leading-tight drop-shadow-2xl" style={{ fontFamily: 'Alice, serif' }}>
            L' Art des Mets
          </h1>
          
          {/* Sous-titre */}
          <p className="text-xl md:text-2xl text-gray-100 mb-8 font-light drop-shadow-lg">
            -Paris-
          </p>
          
          {/* Description */}
          <p className="text-lg text-gray-200 mb-12 max-w-2xl mx-auto leading-relaxed drop-shadow-lg">
            Nous transformons vos événements en expériences culinaires inoubliables. 
            De l'intime au grandiose, notre passion pour l'excellence guide chaque création.
          </p>

          {/* Boutons d'action */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-gradient-to-r from-gray-600 to-gray-400 text-black px-8 py-4 rounded-full font-semibold text-lg hover:from-gray-500 hover:to-gray-300 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-2xl"
            >
              Demander un devis
            </button>
            
            <button
              onClick={() => {
                const element = document.getElementById('galerie');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="border-2 border-white/80 text-white bg-white/10 backdrop-blur-sm px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-black transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-2xl"
            >
              Voir nos créations
            </button>
          </div>
        </div>
      </div>

      {/* Indicateurs de qualité */}
      <div className="absolute bottom-8 left-8 right-8 z-30">
        <div className="flex justify-between items-center max-w-6xl mx-auto">
          <div className="hidden md:flex items-center space-x-8 text-white bg-black/40 backdrop-blur-sm rounded-full px-6 py-3 border border-white/30">
            <div className="flex items-center">
              <i className="ri-award-line text-2xl mr-2"></i>
              <span className="text-sm font-semibold">Chef étoilé</span>
            </div>
            <div className="flex items-center">
              <i className="ri-time-line text-2xl mr-2"></i>
              <span className="text-sm font-semibold">15 ans d'expérience</span>
            </div>
            <div className="flex items-center">
              <i className="ri-map-pin-line text-2xl mr-2"></i>
              <span className="text-sm font-semibold">Paris & Île-de-France</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
